import {
  clearAllBodyScrollLocks,
  disableBodyScroll,
  enableBodyScroll,
} from "body-scroll-lock";
import React, { ReactNode, useEffect, useRef } from "react";
import { State } from "react-burger-menu";
import ReactMenu from "react-burger-menu/lib/menus/slide";
import styled from "styled-components";

const OuterContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  .bm-burger-button {
    display: none;
  }
  .bm-cross-button {
    display: none;
  }
  .bm-menu-wrap {
    background: #fff;

    .bm-menu {
      overflow: initial !important;

      .bm-item-list {
        display: flex;

        > * {
          max-width: 100%;
        }
      }
    }
  }
`;

const InnerContainer = styled.div`
  width: 100%;

  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`;

interface IProps {
  isOpen: boolean;
  toggle: (state: State) => void;
  width?: number | string;
  children?: ReactNode;
}

export const Sidebar = ({
  isOpen,
  toggle,
  width,
  children,
}: IProps): JSX.Element => {
  const menuRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      disableBodyScroll(menuRef.current, {
        allowTouchMove: (el: HTMLElement | null): boolean => {
          while (el && el !== innerRef.current) {
            if (
              el.parentElement &&
              el.scrollHeight > el.parentElement?.scrollHeight
            ) {
              return true;
            }

            el = el.parentElement;
          }

          return false;
        },
      });
    } else {
      enableBodyScroll(menuRef.current);
    }
  }, [isOpen]);

  const isOpenRef = useRef(isOpen);
  isOpenRef.current = isOpen;

  useEffect(() => {
    return (): void => {
      if (isOpenRef.current) {
        clearAllBodyScrollLocks();
      }
    };
  }, []);

  return (
    <OuterContainer id="outer-container">
      <ReactMenu
        pageWrapId={"page-wrap"}
        outerContainerId={"outer-container"}
        width={width}
        isOpen={isOpen}
        onStateChange={toggle}
        ref={menuRef}
      >
        <InnerContainer id="inner" ref={innerRef}>
          {children}
        </InnerContainer>
      </ReactMenu>
    </OuterContainer>
  );
};
